import React, { useMemo } from 'react';

type DynamicLinkProps = {
  href: string;
  text: string;
  openInNewTab?: boolean | string;
};

function DynamicLinkComponent({ href, text, openInNewTab = false }: DynamicLinkProps) {
  // Handle both boolean and string boolean values
  const shouldOpenInNewTab = useMemo(() => {
    if (typeof openInNewTab === 'boolean') return openInNewTab;
    if (typeof openInNewTab === 'string') return openInNewTab.toLowerCase() === 'true';
    return false;
  }, [openInNewTab]);

  const processedHref = useMemo(() => {
    if (!href) return '#';
    
    console.log('DynamicLink - Template href:', href);
    
    // Get URL parameters from current page
    const urlParams = new URLSearchParams(window.location.search);
    
    // Replace variables in href with actual values from URL params
    // Also remove any quotes around the placeholder variables
    let processedUrl = href;
    const variablePattern = /["']?\{([^}]+)\}["']?/g;
    
    processedUrl = processedUrl.replace(variablePattern, (match, variableName) => {
      let value = urlParams.get(variableName.trim());
      console.log('DynamicLink - Variable:', variableName, 'Value:', value);
      if (value !== null) {
        // Remove all surrounding quotes (both single and double) and trim whitespace
        value = value.trim().replace(/^["']+|["']+$/g, '');
      }
      return value !== null ? value : match; // Keep original if not found
    });
    
    console.log('DynamicLink - Final URL:', processedUrl);
    return processedUrl;
  }, [href]);

  return (
    <a 
      href={processedHref}
      target={shouldOpenInNewTab ? '_blank' : '_self'}
      rel={shouldOpenInNewTab ? 'noopener noreferrer' : undefined}
    >
      {text || 'Link'}
    </a>
  );
}

export default DynamicLinkComponent;
